import { render, staticRenderFns } from "./EntityAccountPage.vue?vue&type=template&id=ec23f500&"
import script from "./EntityAccountPage.vue?vue&type=script&lang=js&"
export * from "./EntityAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec23f500')) {
      api.createRecord('ec23f500', component.options)
    } else {
      api.reload('ec23f500', component.options)
    }
    module.hot.accept("./EntityAccountPage.vue?vue&type=template&id=ec23f500&", function () {
      api.rerender('ec23f500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entityAccount/EntityAccountPage.vue"
export default component.exports